import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import _get from 'lodash/get';
import { BotpressConfigPropType } from './BotpressProvider.types';
import { createConfig } from './BotpressProvider.utils';
import Script from '../../../components/Script';
import { GoogleAnalytics } from '../../../services/analytics';
var defaultProps = {
  botpressConfig: {},
  botpressSrc: 'https://cdn.botpress.cloud/webchat/v2.2/inject.js',
  onEvent: function onEvent() {}
};
var BotpressProvider = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var botpressConfig = _ref.botpressConfig,
    botId = _ref.botId,
    clientId = _ref.clientId,
    merchantId = _ref.merchantId,
    botpressSrc = _ref.botpressSrc,
    onEvent = _ref.onEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var botpressRef = useRef(null);
  function handleEvent(event) {
    var isCustomEvent = _get(event, 'type') === 'customEvent';
    if (isCustomEvent) {
      var _get2 = _get(event, 'payload', {}),
        eventType = _get2.eventType,
        _get2$eventData = _get2.eventData,
        eventData = _get2$eventData === void 0 ? {} : _get2$eventData;
      if (eventType === 'glammatic:ga') {
        var category = eventData.category,
          action = eventData.action,
          _eventData$label = eventData.label,
          label = _eventData$label === void 0 ? '' : _eventData$label,
          value = eventData.value;
        GoogleAnalytics.event(category, action, {
          label: label,
          value: value
        });
      }
    }
    onEvent(event);
  }
  function handleScriptLoad() {
    window.botpress.init({
      botId: botId,
      configuration: createConfig(botpressConfig),
      clientId: clientId,
      user: {
        data: {
          merchantId: merchantId
        }
      }
    });
    botpressRef.current = window.botpress;
    setIsLoaded(true);
    botpressRef.current.on('*', handleEvent);
  }
  useEffect(function () {
    // Check if script already exists
    var existingScript = document.getElementById('botpress-script');
    if (existingScript && window.botpress) {
      botpressRef.current = window.botpress;
      setIsLoaded(true);
    }
  }, []);
  useEffect(function () {
    if (isLoaded && botpressRef.current) {
      botpressRef.current.config(createConfig(botpressConfig));
    }
  }, [botpressConfig]);

  // Expose botpress methods via forwarded ref
  useImperativeHandle(ref, function () {
    return {
      sendEvent: function sendEvent() {
        if (isLoaded && botpressRef.current) {
          var _botpressRef$current;
          (_botpressRef$current = botpressRef.current).sendEvent.apply(_botpressRef$current, arguments);
        }
      },
      sendMessage: function sendMessage() {
        if (isLoaded && botpressRef.current) {
          var _botpressRef$current2;
          (_botpressRef$current2 = botpressRef.current).sendMessage.apply(_botpressRef$current2, arguments);
        }
      },
      openChat: function openChat() {
        if (isLoaded && botpressRef.current) {
          botpressRef.current.open();
        }
      },
      closeChat: function closeChat() {
        if (isLoaded && botpressRef.current) {
          botpressRef.current.close();
        }
      },
      toggleChat: function toggleChat() {
        if (isLoaded && botpressRef.current) {
          botpressRef.current.toggle();
        }
      }
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "botpress-provider"
  }, /*#__PURE__*/React.createElement(Script, {
    src: botpressSrc,
    onLoad: handleScriptLoad,
    strategy: Script.STRATEGY_AFTER_USER_INTERACTION
  }));
});
export default BotpressProvider;
BotpressProvider.defaultProps = defaultProps;